export default {
  custom_allergen: {
    placeholder: 'Aggiungi opzione personalizzata',
  },
  buttons: {
    add: 'Aggiungi',
  },
};
